<!-- ugc首页数据分析-->
<template>
   <div class="data-analysis">
        <div class="h1-title">汇总统计</div>
        <div class="numBer">
            <div v-for="(item,index) in statisticsData" :key="index" class="numBer-item" >
                <div class="icon-left-l"><img src="../../../assets/jiantou.png" alt=""></div>
                <div class="right">
                    <!-- <div class="todayNum">前天：{{million(item.yesterdaySum)}}</div> -->
                    <div class="total">累计: {{item.totalSum}}</div>
                    <div class="name"> {{item.type=='Playtime'?item.busiLabel+'/小时':(item.type=='TotalExpenditure'?item.busiLabel: item.busiLabel+'/次'  ) }}</div>
                </div>
            </div>
        </div>
        <ProgramTotal ref="programTotal"></ProgramTotal>
        <MapChart></MapChart>
        <PieChart></PieChart>
   </div>
</template>
<script>
import ProgramTotal from './components/programTotal'
import MapChart from './components/mapChart'
import PieChart from './components/pieChart'
import { getCollectData } from '@/resource/api/ugcIndex.js'
export default {
  name: 'data-analysis',
  components: {
    ProgramTotal,
    MapChart,
    PieChart
  },
  data () {
    return {
      statisticsData: []
    }
  },
  mounted () {
    this.getCollectData()
  },
  methods: {
    // 过万处理
    million (value) {
      let num
      if (value > 9999) { // 大于9999显示x.xx万
        num = (Math.floor(value / 1000) / 10) + 'W'
      } else if (value < 9999 && value >= 0) {
        num = value
      }
      return num
    },
    async getCollectData () {
      try {
        const res = await getCollectData({ stageName: this.$store.state.router.anchorId })
        if (res.code == 1) {
          this.statisticsData = res.result
          this.statisticsData.splice(3, 1)
        }
      } catch (e) {
        this.$message.error(JSON.stringify(e))
      }
    }
  }
}
</script>
<style lang="less" scoped>
  @import "../../../assets/css/dataAnalysis.less";
  .data-analysis{
    .h1-title {
      margin:0 35px;
      padding: 15px 0;
      border-top: solid 1px #eee;
      border-bottom: solid 1px #eee;
    }
    .icon-left-l {
      img {
        display: block;
        width: 50px;
      }
      margin:0 30px;
    }
    .numBer{
      .numBer-item{
        padding: 15px 0;
        .right{
          div{
            margin:5px 0;
          }
        }
      }
    }
  }
</style>
